import { getPlayerBalance, getUsersByID } from "../store/slices/user";

function resolveUserId(user) {
  if (user && typeof user === "object" && user.id) {
    return user.id;
  }

  if (user && typeof user !== "object") {
    return user;
  }

  try {
    const stored = localStorage.getItem("user");
    if (stored) {
      const parsed = JSON.parse(stored);
      return parsed?.id || parsed?.user?.id || parsed?.UserID || null;
    }
  } catch {
    return null;
  }

  return null;
}

export async function refreshUserLaunchState(dispatch, user) {
  const userId = resolveUserId(user);

  if (!dispatch || !userId) {
    return userId;
  }

  await Promise.allSettled([
    dispatch(getUsersByID({ id: userId })),
    dispatch(getPlayerBalance({ id: userId })),
  ]);

  return userId;
}
